<template>
  <div class="people">
    <div class="people__content">
      <div
        v-for="(item, n) in itemList"
        class="people-item"
        :key="n">
        <div class="people-item__image">
          <ModuleImage :imageUrl="item.image" :placeholderUrl="item.placeholderImage" />
          <div
            v-if="n === 2"
            class="people-item__logo">
            <SvgLogo color="#ffffff"/>
          </div>
        </div>
        <div class="people-item__name">
          <h4 class="people-item__name__heading">{{item.text}}</h4>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  name: 'SectionPeople',
  props: {
    itemList: Array
  }
}
</script>
<style lang="scss" scoped>
  @import './section-people'
</style>



// WEBPACK FOOTER //
// src/components/SectionPeople/SectionPeople.vue